<template>
  <div>
    <el-dialog
      v-if="visible"
      :visible.sync="visible"
      show-close
      width="80%"
      :title="$l('table_lable__share_expenses') || '分摊费用'"
      :close-on-click-modal="false"
      :before-close="() => (backDialogVisible = true)"
      v-el-dialog-drag
      destroy-on-close
      append-to-body
    >
      <div class="side-frame-primary">
        <span class="side-frame-text" style="font-weight: 600;">
          {{ $l('table_label_fabric_request_information') || '面料申请单信息' }}
        </span>
      </div>
      <el-descriptions
        border
        v-if="visible"
        size="small"
        :column="5"
        class="mt-1 mb-2 br-s-1"
      >
        <el-descriptions-item
          :label="$l('form_label_fabricNo') || '面料编号'"
          :labelStyle="{ minWidth: '50px' }"
          :contentStyle="{ minWidth: '100px' }"
        >
          <span>{{ fixedData.fabricNo }}</span>
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_fabric_name') || '面料名称'"
          :labelStyle="{ minWidth: '50px' }"
          :contentStyle="{ minWidth: '100px' }"
        >
          <span>{{ fixedData.fabricName }}</span>
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('form_label_fabricContent') || '面料成分'"
          :labelStyle="{ minWidth: '50px' }"
          :contentStyle="{ minWidth: '100px' }"
        >
          <span> {{ fixedData.fabricContent }} </span>
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('table_label_priceInfo') || '单价'"
          :labelStyle="{ minWidth: '50px' }"
          :contentStyle="{ minWidth: '100px' }"
        >
          <span>{{ fixedData.unitPrice }}</span>
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('table_label_fabricUnit') || '单位'"
          :labelStyle="{ minWidth: '50px' }"
          :contentStyle="{ minWidth: '100px' }"
        >
          <span>{{ fixedData.fabricUnitText }}</span>
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('INDEX.quantity') || '数量'"
          :labelStyle="{ minWidth: '50px' }"
          :contentStyle="{ minWidth: '100px' }"
        >
          <span>{{ fixedData.requestQuantity }}</span>
        </el-descriptions-item>

        <el-descriptions-item
          :label="$l('table_label_fabricAmount') || '面料金额'"
          :labelStyle="{ minWidth: '50px' }"
          :contentStyle="{ minWidth: '100px' }"
        >
          <span>{{ fixedData.requestAmount }}</span>
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('table_label_requestFee') || '附加费'"
          :labelStyle="{ minWidth: '50px' }"
          :contentStyle="{ minWidth: '100px' }"
        >
          <span>{{ fixedData.requestFee }}</span>
        </el-descriptions-item>
        <el-descriptions-item
          :label="$l('table_label_currencyAmount') || '费用合计'"
          :labelStyle="{ minWidth: '50px' }"
          :contentStyle="{ minWidth: '100px' }"
        >
          <span>{{ fixedData.currencyAmount }}</span>
        </el-descriptions-item>
      </el-descriptions>
      <ShareTable
        ref="share"
        :tableData="tableData"
        :fixedData="fixedData"
        :fabricRequestCode="fabricRequestCode"
      />

      <span slot="footer">
        <el-button size="small" @click="backDialogVisible = true">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="confirm()">{{
          $l('INDEX.btn_confirm') || '确认'
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      v-el-dialog-drag
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="confirm()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ShareTable from './table.vue'
export default {
  components: { ShareTable },
  props: {
    visible: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
    fabricRequestCode: { type: String, default: '' },
    scmCode: { type: String, default: '' },
    fabricExpenseCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      fixedData: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.fabricRequestCode || !this.scmCode) return
      this.$api
        .fabricExpenseChooseFabricListApi({
          scmCode: this.scmCode,
          fabricExpenseCode: this.fabricExpenseCode,
          keyword: this.fabricRequestCode,
        })
        .then((res) => {
          if (!res) return
          const dataList = res.body.data || []
          if (!dataList || !dataList.length) {
            this.$message.error('未查询到当前面料申请单信息')
            return
          }
          const data = dataList[0]
          this.fixedData = {
            expenseType: '',
            billCount: 0,
            currencyAmount: data.requestTotalAmount,
            fabricCode: data.fabricCode,
            fabricRequestCode: data.fabricRequestCode,
            scmCode: data.supCode,
            scmName: data.supName,
            custCode: data.custCode,
            custName: data.custName,
            bizDate: data.requestDate || '',
            fabricNo: data.fabricNo,
            fabricName: data.fabricName,
            fabricContent: data.fabricContent,
            wid: data.wid,
            widUnit: data.widUnit,
            fabricWeight: data.fabricWeight,
            fabricWeightUnit: data.fabricWeightUnit,
            fabricColorTitle: data.fabricColorTitle || '',
            unitPrice: data.unitPrice || 0,
            requestQuantity: data.requestQuantity || 0,
            fabricUnit: data.fabricUnit,
            fabricUnitText: data.fabricUnitText,
            requestAmount: data.requestAmount || 0,
            requestFee: data.requestFee || 0,
          }
        })
        .catch(() => null)
    },
    async confirm() {
      const validResult = await this.$refs.share.validEvent()
      if (!validResult) return (this.backDialogVisible = false)

      const data = this.$refs.share.getTableData()
      if (!data || !data.length) {
        this.$message.error(this.$l('tips_please_add_data') || '请添加数据')
        return
      }
      this.$emit('share', data)
      this.close()
    },
    close() {
      this.backDialogVisible = false
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-primary {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 10px 0;
}
</style>
